'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'star-half-stroke';
var width = 576;
var height = 512;
var aliases = ["star-half-alt"];
var unicode = 'f5c0';
var svgPathData = ['M53.7 179.9L157.1 283.3c7.2 7.2 10.6 17.5 9 27.6l-22.8 144.4 128.8-65.5 0-348.9-50.5 98.9c-4.6 9.1-13.4 15.5-23.5 17.1l-144.4 23z', 'M309.5-18.9L383 125.3 542.9 150.7c8.9 1.4 16.3 7.7 19.1 16.3s.5 18-5.8 24.4L441.7 305.9 467 465.8c1.4 8.9-2.3 17.9-9.6 23.2s-17 6.1-25 2L288.1 417.6 143.8 491c-8 4.1-17.7 3.3-25-2s-11-14.2-9.6-23.2L134.4 305.9 20 191.4c-6.4-6.4-8.6-15.8-5.8-24.4s10.1-14.9 19.1-16.3l159.9-25.4 73.6-144.2c4.1-8 12.4-13.1 21.4-13.1s17.3 5.1 21.4 13.1zm45.1 158.7l-50.5-98.9 0 348.8 128.8 65.5-22.8-144.4c-1.6-10.1 1.7-20.4 9-27.6l103.3-103.5-144.4-23c-10.1-1.6-18.8-7.9-23.5-17.1zM272.1 40.9l-50.5 98.9c-4.6 9.1-13.4 15.5-23.5 17.1l-144.4 23 103.3 103.5c7.2 7.2 10.6 17.5 9 27.6l-22.8 144.4 128.8-65.5 0-348.9z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;